import React, { useEffect, useState, useRef } from 'react';
import { Clock, Award, Users, FileCheck } from 'lucide-react';
export default function StatsSection() {
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState({
    experience: 0,
    reports: 0,
    clients: 0,
    turnaround: 0
  });
  const sectionRef = useRef(null);
  const finalCounts = {
    experience: 20,
    reports: 500,
    clients: 300,
    turnaround: 5
  };
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.3
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    const duration = 2000;
    const steps = 60;
    const increment = {
      experience: finalCounts.experience / steps,
      reports: finalCounts.reports / steps,
      clients: finalCounts.clients / steps,
      turnaround: finalCounts.turnaround / steps
    };
    let currentStep = 0;
    const timer = setInterval(() => {
      currentStep++;
      if (currentStep <= steps) {
        setCounts({
          experience: Math.min(Math.floor(increment.experience * currentStep), finalCounts.experience),
          reports: Math.min(Math.floor(increment.reports * currentStep), finalCounts.reports),
          clients: Math.min(Math.floor(increment.clients * currentStep), finalCounts.clients),
          turnaround: Math.min(Math.floor(increment.turnaround * currentStep), finalCounts.turnaround)
        });
      } else {
        clearInterval(timer);
      }
    }, duration / steps);
    return () => clearInterval(timer);
  }, [isVisible]);
  const stats = [{
    icon: <Award className="h-10 w-10 md:h-12 md:w-12" data-id="element-231" data-mp="nif6mqcjabw6" />,
    value: counts.experience,
    suffix: '+',
    label: 'Years Experience',
    color: 'text-secondary'
  }, {
    icon: <FileCheck className="h-10 w-10 md:h-12 md:w-12" data-id="element-232" data-mp="wghi5ztw8mxp" />,
    value: counts.reports,
    suffix: '+',
    label: 'Reports Delivered',
    color: 'text-secondary'
  }, {
    icon: <Users className="h-10 w-10 md:h-12 md:w-12" data-id="element-233" data-mp="16enfe44r94w8" />,
    value: counts.clients,
    suffix: '+',
    label: 'Satisfied Solicitors',
    color: 'text-secondary'
  }, {
    icon: <Clock className="h-10 w-10 md:h-12 md:w-12" data-id="element-234" data-mp="1f7qoy1ca4xll" />,
    value: counts.turnaround,
    suffix: '',
    label: 'Working Days Turnaround',
    color: 'text-secondary'
  }];
  return <section ref={sectionRef} className="py-16 bg-gradient-to-br from-primary via-primary-dark to-primary text-white" data-id="element-235" data-mp="1p6pxzl0yiv94">
      <div className="container mx-auto px-4" data-id="element-236" data-mp="1u5sswcn83l3d">
        <div className="text-center mb-12" data-id="element-237" data-mp="3en22643fuuox">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-238" data-mp="3eo3gchfr3xav">
            Trusted by Legal Professionals Across the UK
          </h2>
          <p className="text-lg md:text-xl opacity-90 max-w-2xl mx-auto" data-id="element-239" data-mp="34p5u5l5ssfv1">
            Our track record speaks for itself
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-240" data-mp="2zrcl8kd417r2">
          {stats.map((stat, index) => <div key={index} className="bg-white/10 backdrop-blur-sm rounded-lg p-6 md:p-8 text-center transform transition-all hover:scale-105 hover:bg-white/20 card-lift" style={{
          animationDelay: `${index * 0.1}s`
        }} data-id="element-241" data-mp="17njz72jywrg" data-mpi={index}>
              <div className={`${stat.color} mb-4 flex justify-center animate-pulse-slow`} data-id="element-242" data-mp="3imud2ngb1cxg">
                {stat.icon}
              </div>
              <div className="text-3xl md:text-4xl lg:text-5xl font-bold mb-2 animate-count-up" data-id="element-243" data-mp="f7eugxtv1v0p">
                {stat.value}
                {stat.suffix}
              </div>
              <div className="text-sm md:text-base opacity-90 font-medium" data-id="element-244" data-mp="4pt84qdj2r1k">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}